export const SITE_TITLE = 'SMARTY'
